export const getProductCustomField = (data, field) => {
  try {
    const prop = JSON.parse(data.properties[field])
    return prop != null ? prop : null
  } catch (error) {
    return null
  }
}
